import script from "./HolidayRemote.vue?vue&type=script&setup=true&lang=ts"
export * from "./HolidayRemote.vue?vue&type=script&setup=true&lang=ts"

import "./HolidayRemote.vue?vue&type=style&index=0&id=a8eccc08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8eccc08"]])

export default __exports__